/* unplugin-vue-components disabled */import { render } from "./StereoscopicSectionExamRender.vue?vue&type=template&id=ba52630e&scoped=true"
import script from "./StereoscopicSectionExamRender.vue?vue&type=script&lang=js"
export * from "./StereoscopicSectionExamRender.vue?vue&type=script&lang=js"

import "./StereoscopicSectionExamRender.vue?vue&type=style&index=0&id=ba52630e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba52630e"]])

export default __exports__